export default __webpack_public_path__ + "static/media/FirstBase-4.984400db.jpg";